import { render, staticRenderFns } from "./flexbox-item.vue?vue&type=template&id=623889ca&"
import script from "./flexbox-item.vue?vue&type=script&lang=js&"
export * from "./flexbox-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.3.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/erp_Product/erp_front/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('623889ca', component.options)
    } else {
      api.reload('623889ca', component.options)
    }
    module.hot.accept("./flexbox-item.vue?vue&type=template&id=623889ca&", function () {
      api.rerender('623889ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flexbox/flexbox-item.vue"
export default component.exports